import React, { Fragment, useState } from "react";
import expanderIcon from "../../assets/chevron-icon.svg";
import { getElixirMids, getOtherMids } from "../../common/merchantHelper";

const SystemIdListContainer = (props) => {
  const Expander = () => {
    const expanderMarkup = { __html: expanderIcon };
    return (
      <tr className={"expander"} onClick={() => setIsExpanded(!isExpanded)}>
        <td colSpan="2">
          <div dangerouslySetInnerHTML={expanderMarkup} className={`expander-icon ${isExpanded ? "open" : "closed"}`} />
        </td>
      </tr>
    );
  };

  const [isExpanded, setIsExpanded] = useState(false);
  const merchantDetails = props.impersonation.merchantDetails;
  const elixirMids = getElixirMids(merchantDetails);
  const otherMids = getOtherMids(merchantDetails);
  const mids = elixirMids.concat(otherMids).sort((a, b) => (a.system > b.system ? 1 : -1));

  return (
    <div className="user-table">
      <h2>MIDs & IDs</h2>
      <table className="table">
        <thead>
          <Expander {...isExpanded} />
        </thead>
        {isExpanded ? (
          <Fragment>
            <thead>
              <tr>
                <th width="60%">Id</th>
                <th width="40%">System</th>
              </tr>
            </thead>
            <tbody>
              {mids.map((mid, i) => (
                <tr key={i}>
                  <td>
                    <code title={mid.system_id}>{mid.system_id}</code>
                  </td>
                  <td className="system-id">{mid.system}</td>
                </tr>
              ))}
            </tbody>
          </Fragment>
        ) : null}
      </table>
    </div>
  );
};

export default SystemIdListContainer;
